import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const SelectWrapper = styled.div`
  margin-bottom: ${theme.space_size};
  label {
    span {
      color: ${theme.colours.error};
      font-size: 15px;
    }
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.blackText};
      margin-bottom: 8px;
      display: inline-block;
    }
  }

  .mantine-Select-root.hasError .mantine-Select-input {
    border: 1px solid ${theme.colours.error} !important;
  }

  .mantine-Select-root {
    cursor: pointer;
    input {
      height: auto;
      padding-block: 2px;
      border-radius: 8px;
      color: ${theme.colours.blackText};
      font-family: ${theme.fonts.Regular};
      font-size: 13px;
      padding-inline-start: 12px;
      border: 1px solid ${theme.colours.SpanishGray};
      &:lang(ar) {
        text-align: right;
      }
      &:focus {
        font-size: 13px;
      }
      &::placeholder {
        color: ${theme.colours.SpanishGray};
      }
    }
    .mantine-Select-rightSection {
      &:lang(ar) {
        left: 0;
        right: auto;
      }
    }
  }
`;
